$(function() {
    $(document).on("click", ".paginator li", function(evt) {
        evt.preventDefault();

        //Disabled buttons no-no
        if($(this).hasClass("disabled")) {
        	return false;
        }

        if($(this).hasClass("active")) {
            return false;
        }

        if($(window).width() < 767) {
            $("#content").css("overflow", "hidden");
            setTimeout( function() {
                $("#content").css("overflow", "");
            }, 32);
        }
        
        $("#quick-search-form #pageNumber").val($(this).data("page"));
        $("#quick-search-form").submit();
    });

    $(document).on(Search.evtSearchComplete, function(evt, result, search) {
        $(".paginator").html(result.htmlPagination);
    });
    
});



//////////////////
// WEBPACK FOOTER
// ./src/js/_components/paginator.js
// module id = 18
// module chunks = 6